import { useLocation, useNavigate } from "react-router-dom";
import React, { useCallback, useState } from "react";
import Toast from "../../../components/toast";
import {
  EEnvironmentType,
  environmentValidationSchema,
  IEnvironment,
} from "../../../models/environment";
import { EnvironmentService } from "../../../services/environment-service";
import { useFormik } from "formik";
import { DivForm, TextFieldLogin } from "../../auth/login/styles";
import {
  ButtonCancel,
  ButtonCreate,
  DivButton,
  DivFormInputs,
  DivTitle,
} from "../../user/create/style";
import FormCreate from "../../../components/form-create";
import { BsFillPersonVcardFill, BsPersonLock } from "react-icons/bs";
import { StyledFormControl } from "../create/styles";
import { InputLabel, MenuItem, Select } from "@mui/material";
import PageContainer from "../../../components/page-container";

export default function UpdateEnvironment() {
  const navigate = useNavigate();
  const location = useLocation();

  const [data] = useState<IEnvironment>(location.state);
  const [loading, setLoading] = useState(false);

  const validateForm = () => {
    form.validateForm(form.values).then((errors) => {
      Object.entries(errors).map((error) =>
        Toast.error(error[1])
      );
    });
  };

  const handleUpdate = useCallback(async (env: IEnvironment) => {
    const result = await EnvironmentService.updateEnvironments(env);
    if (typeof result === "object") {
      Toast.success("Ambiente atualizado com sucesso!");
    }
  }, []);

  const form = useFormik({
    initialValues: {
      id: data.id,
      name: data.name,
      username: data.username,
      description: data.description,
      password: data.password,
      baseUrl: data.baseUrl,
      active: data.active,
      environmentType: data.environmentType,
    },

    validationSchema: environmentValidationSchema,
    onSubmit: (values: IEnvironment) => {
      values.password = values.password === "Encrypted" ? undefined : values.password;
      handleUpdate(values).then(() => {
        navigate("/environments/listar");
        setLoading(false);
      });
      setLoading(true);
    },
    validateOnChange: false,
  });
  return (
    <PageContainer>
      <DivForm onSubmit={form.handleSubmit}>
        <DivTitle>
          <h2>Atualizar Ambiente</h2>
        </DivTitle>
        <DivFormInputs>
          <FormCreate
            title="Informações Descritivas"
            icon={<BsFillPersonVcardFill fontSize={25} />}
          >
            <TextFieldLogin
              fullWidth
              label="Nome"
              name={"name"}
              id={"name"}
              variant="standard"
              value={form.values.name}
              onChange={form.handleChange}
            />
            <TextFieldLogin
              fullWidth
              label="Descrição"
              name={"description"}
              id={"description"}
              variant="standard"
              value={form.values.description}
              onChange={form.handleChange}
            />
            <StyledFormControl variant="standard">
              <InputLabel variant={"standard"} id="environmentType">
                Tipo do Environment
              </InputLabel>
              <Select
                labelId="environmentType"
                id="environmentType"
                label="Tipo do Environment"
                value={form.values.environmentType}
                onChange={(e) => {
                  form.setValues({
                    ...form.values,
                    environmentType: e.target.value as EEnvironmentType,
                  });
                }}
              >
                <MenuItem value="">
                  <em></em>
                </MenuItem>
                <MenuItem
                  id={EEnvironmentType.PRD}
                  value={EEnvironmentType.PRD}
                >
                  Produção
                </MenuItem>
                <MenuItem
                  id={EEnvironmentType.HML}
                  value={EEnvironmentType.HML}
                >
                  Homologação
                </MenuItem>
                <MenuItem
                  id={EEnvironmentType.DEV}
                  value={EEnvironmentType.DEV}
                >
                  Desenvolvimento
                </MenuItem>
              </Select>
            </StyledFormControl>
          </FormCreate>
          <FormCreate
            title="Informações Autenticação"
            icon={<BsPersonLock fontSize={25} />}
          >
            <TextFieldLogin
              fullWidth
              label="Usuário"
              name={"username"}
              id={"username"}
              variant="standard"
              value={form.values.username}
              onChange={form.handleChange}
            />
            <TextFieldLogin
              fullWidth
              label="Senha"
              name={"password"}
              type="password"
              id={"password"}
              variant="standard"
              value={form.values.password}
              onChange={form.handleChange}
            />
            <TextFieldLogin
              fullWidth
              label="URL"
              name={"baseUrl"}
              id={"baseUrl"}
              variant="standard"
              value={form.values.baseUrl}
              onChange={form.handleChange}
            />
          </FormCreate>
        </DivFormInputs>
        <DivButton>
          <ButtonCancel
            type={"reset"}
            onClick={() => navigate("/environments/listar")}
          >
            Cancelar
          </ButtonCancel>
          <ButtonCreate
            type={"submit"}
            onClick={validateForm}
            disabled={loading}
          >
            Salvar
          </ButtonCreate>
        </DivButton>
      </DivForm>
    </PageContainer>
  );
}
